// popupSlice.js
import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import axios from 'axios'
import {ENV} from '../../Utils/_helpers/EnvHelper'

const API_URL = ENV().REACT_APP_API_URL

const initialState = {
  showPopup: false,
  popupContent: null,
  sessionShowPopup: false,
  sessionTime: null,
  contactUploadPopup: false,
  StartUploadPopup: false,
  firstTimeApproval: {},
}

export const FirstTimeApprovalData: any = createAsyncThunk(
  '/FirstTimeApprovalData',
  async (data: any, thunkApi: any) => {
    const response: any = await axios.get(`${API_URL}user/checkFirstApprovalBanner`, {
      params: data,
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    return response?.data
  }
)

const popupSlice: any = createSlice({
  name: 'popup',
  initialState,
  reducers: {
    openPopup: (state, action) => {
      state.showPopup = true
      state.popupContent = action.payload
    },
    closePopup: (state) => {
      state.showPopup = false
      state.popupContent = null
    },
    sessionOpenPopup: (state) => {
      state.sessionShowPopup = true
    },
    sessionClosePopup: (state) => {
      state.sessionShowPopup = false
    },
    ContactOpenPopup: (state) => {
      state.contactUploadPopup = true
    },
    ContactClosePopup: (state) => {
      state.contactUploadPopup = false
    },
    ContactStartUpload: (state) => {
      state.StartUploadPopup = true
    },
    ContactEndUpload: (state) => {
      console.log('contactStartUpload')

      state.StartUploadPopup = false
    },
  },
  extraReducers: (builder) => {
    builder.addCase(FirstTimeApprovalData.fulfilled, (state, {payload}) => {
      return {...state, firstTimeApproval: payload}
    })
  },
})

export const {
  openPopup,
  closePopup,
  sessionOpenPopup,
  sessionClosePopup,
  ContactOpenPopup,
  ContactClosePopup,
  ContactStartUpload,
  ContactEndUpload,
} = popupSlice.actions
export default popupSlice.reducer
